const PaymentsProviders = {
    AIRTEL : 'danger',
    MTN : 'warning',
    ZAMTEL : 'success',
    VISAMASTERCARD : 'info',
    TOTAL:'primary'
}

export default PaymentsProviders